import { Clinic } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

interface UseClinicsByAdvertisementIdParams {
  advertisement_id: number | string
}

export function useClinicsByAdvertisementId({
  advertisement_id,
}: UseClinicsByAdvertisementIdParams) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ApiResponse<Clinic[]>>(
    token && advertisement_id ? `/api/advertisements/${advertisement_id}/scheduled-clinics` : null,
    undefined,
    token ?? '',
  )

  return {
    clinics: data?.data || [],
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
